import { Injectable } from '@angular/core';
import { SessionUser } from '../types/types';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }

  clear(): void {
    sessionStorage.clear();
  }

  get(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  set(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  remove(key: string): void {
    sessionStorage.removeItem(key);
  }

  getUser(): SessionUser {
    const user = sessionStorage.getItem('currentUser');
    return (user ? JSON.parse(user) : undefined);
  }

  setUser(user: SessionUser, token: string, provider?: string) {
    sessionStorage.setItem('currentUser', JSON.stringify(user));
    this.set('token', token);
    if (provider != undefined && provider != null) this.set('provider', provider);
  }

  removeUser(): void {
    sessionStorage.removeItem('currentUser');
    this.remove('token');
  }

}